<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Διαγραφή Εργαζομένου</v-card-title>
    <v-form class="form d-flex flex-column justify-center">
      <div>Είστε σίγουροι ότι θέλετε να διαγράψετε μόνιμα το χρήστη?</div>
      <div class="d-flex justify-center mt-16">
        <v-btn
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onDelete"
        >
          <span>Διαγραφή</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>
  
  <script>
import { mapActions } from "vuex";
export default {
  props: ["currentUser"],

  data() {
    return {
      loader: false,
    };
  },

  computed: {},

  methods: {
    ...mapActions(["removeHcmcUser"]),
    async onDelete() {
      try {
        this.loader = false;
        //   this.removeHcmcUser({
        //     HcmcEmployeeId: this.employeeId,
        //   });
        this.loader = true;
        this.$emit("closeDialog");
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>
  
  <style scoped lang='scss'>
</style>